<template>
    <div class="login">
        <div class="logo_box">
            <img src="../assets/static/login/log_logo.png" alt="">
        </div>
        <div class="form_box">
            <div class="left"></div>
            <div class="right">
                <!-- <div class="title">
                    智慧党建平台
                </div> -->
                <div class="input_box">
                    <img src="../assets/static/login/log_ico01.png" alt="">
                    <input type="text" class="finp" v-model="phone" placeholder="请输入手机号码">
                </div>
                <div class="input_box">
                    <img src="../assets/static/login/log_ico02.png" alt="">
                    <input type="password" class="finp" v-model="password" placeholder="请输入密码">
                </div>
                <div class="input_box">
                    <img src="../assets/static/login/log_ico03.png" alt="">
                    <input type="text" class="code" v-model="checkCode" placeholder="请输入验证码">
                    <div class="code_box" >
                        <YanZhenMa @getResultCode="getCode"  ref="yzm" />
                    </div>
                </div>
                <div class="btn_box" @click="login" >
                    登录
                </div>
            </div>
        </div>
    </div>  
</template>

<script>
    import { JSEncrypt } from 'jsencrypt'
    const decrypt = new JSEncrypt()
    import YanZhenMa from "@/components/common/YanZhenMa"
    export default {
        components: {
            YanZhenMa
        },
        data() {
            return {
                checkCode: "",
                resultCode: "",
                phone: "",
                password: "",
                publicKey: "",
            }
        },
        mounted() {
            window.addEventListener("keydown", this.keyEvent)
        },
        beforeDestroy() {
            window.removeEventListener("keydown",this.keyEvent)
        },
        methods: {
            // 键盘事件
            keyEvent( ev ) {
                 // console.log(ev)
                let code = ev.keyCode 
                let route = this.$route.path
                console.log(route )
                if ( code == 13 && route == "/login" ) {
                    this.login()
                }
            },
            
            // 验证码初始化
            codeReady ( code ) {
                // console.log( code )
                this.checkCode = code.$data.codeChose
            },
            // 重新舒适化
            codeSuccess ( el ) {
                el.refresh()
                this.codeReady()
            },
            // 获取验证码
            getCode ( code ) {
                // console.log( code )
                this.resultCode = code 
            },
            // 获取publickKey
            async getPublicKey () {
                let res = await this.$axios.post("/lencon/pc/login/getPublicKey")
                console.log( res )
                if ( res.data.code == 1 ) {
                    this.publicKey = res.data.publicKeyString
                    decrypt.setPublicKey( this.publicKey );
                }
            },
            // 点击登录
            async login () {
                await this.getPublicKey()
                let { phone, password, checkCode, publicKey, resultCode } = this 
                if ( !phone ) {
                    return this.$message.error("请输入手机号码")
                } else if ( !password ) {
                    return this.$message.error("请输入密码")
                } else if ( !checkCode ) {
                    return this.$message.error("请输入验证码")
                } else if ( checkCode != resultCode ) {
                    return this.$message.error("验证码错误")
                } else if ( !publicKey ) {
                    return this.$message.error("为获取到公钥")
                } else {
                    password = decrypt.encrypt( password ) // 密码加密
					phone = decrypt.encrypt( phone )
                    let res = await this.$axios.post("/lencon/pc/login/login", { phone, password, publicKey })
                    this.$refs.yzm.randomNUmber()
                    if ( res.data.code == 1 ) {
                        this.$message.success( res.data.msg )
                        let token = res.data.token 
                        localStorage.setItem("token", token)
                        this.$store.commit("getToken", token )
                        this.$router.push("/")
                    } else {
                        this.$message.error( res.data.msg )
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.login {
    width: 100%;
    height: 100%;
    background: url("../assets/static/login/log_bg1.jpg") 0 0 no-repeat;
    background-size: 100% 100%;
    position: relative;
    left: 0;
    top: 0;
    .logo_box {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        padding-top: 100px;
    }
    .form_box {
        width: 1200px;
        height: 600px;
        // position: absolute;
        // left: 50%;
        // top: 55%;
        // margin-left: -550px;
        // margin-top: -300px;
        margin: 20px auto;
        background: url("../assets/static/login/log_bg2.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        display: flex;
        border-radius: 25px;
        overflow: hidden;
        .left {
            width: 600px;

        }
        .right {
            flex: 1;
            padding-top: 100px;
            .title {
                font-size: 36px;
                font-weight: bold;
                color: red;
                text-align: center;
                line-height: 80px;
                margin-bottom: 60px;
            }
            .input_box {
                width: 400px;
                height: 60px;
                margin: 30px auto;
                box-sizing: border-box;
                // border-radius: 30px;
                overflow: hidden;
                border-bottom: 1px solid #DBDBDB;
                display: flex;
                position: relative;
                left: 0;
                top: 0;
                img {
                    position: absolute;
                    left: 15px;
                    top: 15px;
                    width: 30px;
                    height: 30px;
                    line-height: 60px;
                }
                .finp {
                    width: 100%;
                    height: 60px;
                    outline: none;
                    border: none;
                    padding: 0 20px 0 60px;
                    line-height: 60px;
                    background-color: transparent;
                }
                .code {
                    border: none;
                    outline: none;
                    width: 300px;
                    padding: 0 20px 0 60px;
                    background-color: transparent;
                }
            }
            .btn_box {
                width: 400px;
                height: 60px;
                background: #D10D19;
                box-shadow: 0px 5px 10px 0px rgba(144, 138, 135, 0.15);
                border-radius: 30px;
                border: none;
                outline: none;
                margin: 20px auto;
                text-align: center;
                line-height: 60px;
                color: #fff;
                cursor: pointer;
                font-size: 26px;
                letter-spacing: 10px;
                font-weight: bold;
            }
        }
    }
}
</style>